define('gameday-device-interaction/lib/android',['require','exports','module','./DeviceInteraction'],function(require,exports,module){
    var DeviceInteraction = require( "./DeviceInteraction" );

    var cardPrefix = 'Player Card : ';
    function AndroidInteraction(selectors){
        selectors = selectors || {};
        this.dispatcher = window.NATIVE;
        AndroidInteraction.superclass.constructor.call(this);;
    }

    AndroidInteraction.dispatcherAvailable = !!window.NATIVE;

    DeviceInteraction.spawn(AndroidInteraction)
        .define({
            type        : "android",
            track       : function(data){
                this.dispatcher.track(data.gid, data.view, data.detail, !!data.isPassive);
                return true;
            },
            video       : function(data){
                this.dispatcher.playVideoHighlight(data.url, data.vid || data.id, data.title|| data.headline || '');
                return true;
            },
            playercard  : function(data){
                data.external = false;
                data.title = data.title || (cardPrefix + data.name);
                data.url = data.url || "http://mlb.mlb.com/mlb/gameday/responsive/player/android.html#pid="+(data.pid || data.playerid) + ",lang="+(data.lang||'en');
                return this.webview(data);
            },
            webview     : function(data){
                this.dispatcher.openWebView(data.title|| data.headline || '', data.url, data.external===false);
                return true;
            },
            share       : function(data){
                this.dispatcher.share(data.title || data.headline || '', data.vid || data.id);
                return true;
            }

        });
    return AndroidInteraction;
});
